import React, {useEffect, useRef, useState} from 'react';
import {useCookies} from 'react-cookie';

import {useIdentityContext} from '@fo/shared-providers/IdentityContext';
import {useSetModalContent} from '@fo/shared-providers/ModalContextProvider';
import {SIGNUP_COOKIE_DISPLAY_TIMEOUT, SIGNUP_COOKIE_NAME} from '@fo/shared-types/constants';
import useWithCookiesConsent from '@fo/shared-hooks/useWithCookiesConsent';
import {segmentEvents, track} from '@fo/shared-analytics/tracking/segment';

import SignupModal from './SignupModal';

// Null render component to conditionally show modal. Must be used inside Modal context
function IncludeSignupModal(): null {
  const [cookies, setCookies] = useCookies();
  const [isShowModal, setIsShowModal] = useState(false);
  const setModalContent = useSetModalContent();
  const modalTimeoutRef = useRef<number | undefined>();
  const {isLoggedIn} = useIdentityContext();

  const setModalAfterCookieConsent = useWithCookiesConsent(() => setIsShowModal(true));

  const delayedSetModal = () => {
    modalTimeoutRef.current = window.setTimeout(() => {
      setModalAfterCookieConsent();
    }, SIGNUP_COOKIE_DISPLAY_TIMEOUT);
  };

  useEffect(() => {
    if (!isLoggedIn) {
      const signupCookie = cookies[SIGNUP_COOKIE_NAME];

      if (!isShowModal) {
        delayedSetModal();
      }

      if (isShowModal && !signupCookie) {
        setCookies(SIGNUP_COOKIE_NAME, true, {
          maxAge: 30 * 24 * 60 * 60, // 30 days
        });
        track(segmentEvents.actions.modalMailingListSignupLoad, {
          url: window?.location.href,
        });
        const isModalAllowed = setModalContent(<SignupModal />);
        if (!isModalAllowed) {
          setIsShowModal(false);
          delayedSetModal();
        }
      }
    }

    return () => {
      window.clearTimeout(modalTimeoutRef.current);
    };
  }, [cookies, isShowModal]);

  return null;
}

export default IncludeSignupModal;
